import script from "./ResourceList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResourceList.vue?vue&type=script&lang=ts&setup=true"

import "./ResourceList.vue?vue&type=style&index=0&id=150ab95d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-150ab95d"]])

export default __exports__